import React, { useState, FC, JSX } from 'react';
import { Link } from 'react-router-dom';
import useScrollToTop from '../hooks/useScrollToTop';
import logoImage from '../assets/logo-top-left.svg';


/* ─────────────────────────────────────────────
   Design tokens (matched exactly to Figma)
───────────────────────────────────────────── */
const GREEN = '#6fc86f';          // CTA / active-tab colour
const GREEN_DARK = '#007000';     // Hindi tagline / "employer?" link
const GREEN_BADGE_BG = '#b6deb6'; // Hero badge background
const GREEN_BADGE_TEXT = '#0f6e0f'; // Hero badge text
const SECTION_GRAY = '#f6f6f6';   // Section background (How Dhoondh, Featured Jobs cards)
const OFFERS_BG = '#f3faf0';      // What Dhoondh Offers section bg
const OFFERS_BORDER = '#e3f1dd';  // What Dhoondh Offers section border
const CARD_INNER_BG = '#e7f2e7';  // Inner preview card bg
const CARD_INNER_BORDER = '#b9d6b9'; // Inner preview card border
const TEXT_SUBTITLE = '#4c4c4c';  // Hero subtitle / body text

/* ─────────────────────────────────────────────
   Static data
───────────────────────────────────────────── */
const sliderColumn1 = [
  '/newHome/slider_1/Mask group.png',
  '/newHome/slider_1/Mask group-1.png',
  '/newHome/slider_1/Mask group-2.png',
  '/newHome/slider_1/Mask group-3.png',
  '/newHome/slider_1/Mask group-4.png',
];

const sliderColumn2 = [
  '/newHome/slider_2/Mask group.png',
  '/newHome/slider_2/Mask group-1.png',
  '/newHome/slider_2/Mask group-2.png',
  '/newHome/slider_2/Mask group-3.png',
  '/newHome/slider_2/Mask group-4.png',
];

const collegeLogos = [
  { name: 'University',       src: '/newHome/trusted_colleges/msu_uni.png' },
  { name: 'Woxsen',           src: '/newHome/trusted_colleges/woxsen_uni.png' },
  { name: 'Sigma University', src: '/newHome/trusted_colleges/sigma_uni.png' },
  { name: 'XIM University',   src: '/newHome/trusted_colleges/ximi_uni.png' },
  { name: 'NUV',              src: '/newHome/trusted_colleges/nuv_uni.png' },
];

const trustedCompanies = [
  // { name: 'Company 1', src: '/newHome/trusted_companies/company1.png' },
  { name: 'Company 2', src: '/newHome/trusted_companies/company2.png' },
  { name: 'Company 3', src: '/newHome/trusted_companies/company3.png' },
  { name: 'Company 4', src: '/newHome/trusted_companies/company4.png' },
  { name: 'Company 5', src: '/newHome/trusted_companies/company5.png' },
  // { name: 'Company 6', src: '/newHome/trusted_companies/company6.png' },
  { name: 'Company 7', src: '/newHome/trusted_companies/company7.png' },
  { name: 'Company 8', src: '/newHome/trusted_companies/company8.png' },
  { name: 'Company 9', src: '/newHome/trusted_companies/company9.png' },
  { name: 'Company 10', src: '/newHome/trusted_companies/company10.png' },
  // { name: 'Company 11', src: '/newHome/trusted_companies/company11.png' },
  { name: 'Company 12', src: '/newHome/trusted_companies/company12.png' },
  { name: 'Company 13', src: '/newHome/trusted_companies/company13.png' },
  { name: 'Company 14', src: '/newHome/trusted_companies/company14.png' },
];

const jobseekerSteps = [
  { number: '1', title: 'Create Your Profile in 5 Minutes',  description: 'Add your skills and experience in just 2 minutes.' },
  { number: '2', title: 'Smart AI Matchmaking',               description: 'AI provides suitable job options.' },
  { number: '3', title: 'Fast-Track Your Interviews',         description: 'Capture employer interest in a matter of minutes.' },
  { number: '4', title: 'Get Hired for Free',                 description: "We don't stop working until you get hired." },
];

const employerSteps = [
  { number: '1', title: 'Post Your Job in 2 Minutes',    description: 'Add job details and requirements quickly.' },
  { number: '2', title: 'AI Finds Perfect Candidates',   description: 'Our AI matches you with qualified candidates.' },
  { number: '3', title: 'Review & Shortlist',            description: 'Easily review applications and shortlist candidates.' },
  { number: '4', title: 'Hire the Best Talent',          description: 'Connect and hire without any fees.' },
];

const categories = [
  // {
  //   name: 'Technology',
  //   jobs: 71,
  //   logos: [
  //     // '/newHome/featured_jobs/urban_company.png',
  //     '/newHome/featured_jobs/ancile_digital.jpeg',
  //     // '/newHome/featured_jobs/infosis.png',
  //   ],
  // },
  {
    name: 'FMCG & Retail',
    jobs: 186,
    logos: [
      '/newHome/featured_jobs/hungry_picnic.jpeg',
      '/newHome/featured_jobs/bonding_gifts.png',
      '/newHome/featured_jobs/agro_furniture.png',
    ],
  },
  {
    name: 'HealthCare',
    jobs: 97,
    logos: [
      '/newHome/featured_jobs/avante.jpeg',
      '/newHome/featured_jobs/wealthcraft_lifestyle.png',
      '/newHome/featured_jobs/lic.png',
    ],
  },
  {
    name: 'Manufacturing',
    jobs: 121,
    logos: [
      '/newHome/featured_jobs/brick_store.png',
      '/newHome/featured_jobs/parson_adhesives.jpeg',
      '/newHome/featured_jobs/avante.jpeg',
      '/newHome/featured_jobs/ami_lifescience.jpeg',
    ],
  },
  {
    name: 'Hospitality',
    jobs: 21,
     logos: [
      '/newHome/featured_jobs/yantraman.jpeg',
      '/newHome/featured_jobs/jk_eng.png',
    ],
  },
  {
    name: 'Consulting',
    jobs: 56,
    logos: [
      '/newHome/featured_jobs/yd_advisory.png',
      '/newHome/featured_jobs/rhine_advisory.png',
      '/newHome/featured_jobs/kaisen_advisory.png',
    ],
  },
  {
    name: 'Engineering',
    jobs: 22,
     logos: [
      '/newHome/featured_jobs/shreeji.png',
      '/newHome/featured_jobs/awwons.jpeg',
      '/newHome/featured_jobs/jk_eng.png',
    ],
  },
];

const featuredJobs = [
  {
    company: 'Urban Company',
    logo: '/newHome/featured_jobs/urban_company.png',
    role: 'Business Development',
    tags: [['Urgent Hiring', 'Pune'], ['Hybrid', 'Hospitality']],
  },
  {
    company: 'LIC',
    logo: '/newHome/featured_jobs/lic.png',
    role: 'Business Development',
    tags: [['Urgent Hiring', 'Vadodara'], ['Lifestyle', '5+ years exp']],
  },
  {
    company: 'YD Advisory',
    logo: '/newHome/featured_jobs/yd_advisory.png',
    role: 'Consultant',
    tags: [['Urgent Hiring', 'Delhi'], ['On-Site', '3+ years exp']],
  },
  {
    company: 'JCB',
    logo: '/newHome/featured_jobs/jcb.png',
    role: 'Sales Executive',
    tags: [['Urgent Hiring', 'Vadodara'], ['Service', '2+ years exp']],
  },
];

/* Typed offer data -------------------------------------------------- */
type OfferPreview =
  | { type: 'job';          bgColor: string; bgBorder: string; logo: string; company: string; role: string; tags: string[] }
  | { type: 'contractual';  workerImage: string; tag: string }
  | { type: 'profile';      avatar: string; name: string; role: string; tags: string[] }
  | { type: 'placement';    image: string; tags: string[] }
  | { type: 'illustration'; image: string };

interface OfferItem { title: string; description: string; link: string; preview: OfferPreview }

const dhoondhOffers: OfferItem[] = [
  {
    title: 'White Collar Jobs',
    description: 'From finance to design—find verified experts or land your next career move with confidence.',
    link: '/services',
    preview: {
      type: 'job',
      bgColor: '#e7f2e7',
      bgBorder: '#b9d6b9',
      logo: '/newHome/featured_jobs/urban_company.png',
      company: 'Urban Company',
      role: 'Senior Software Engineer',
      tags: ['Urgently Hiring', 'Gurugram', 'Hybrid'],
    },
  },
  {
    title: 'Contractual Hiring',
    description: 'Select from thousands of verified workers for your factory, warehouse or production needs.',
    link: '/services',
    preview: {
      type: 'contractual',
      workerImage: '/newHome/dhoondh_offers/Mask group.png',
      tag: 'Multiple Staff Required',
    },
  },
  {
    title: 'Resume Builder',
    description: 'Your resume, professionally done. Stand out to employers with a clean, recruiter-approved format.',
    link: '/services',
    preview: {
      type: 'profile',
      avatar: '/newHome/dhoondh_offers/Resume_info.png',
      name: 'Reeta Sinha',
      role: 'Customer Relationship Manager',
      tags: ['Immediate Joiner', 'Patna, Bihar', '6 years'],
    },
  },
  {
    title: 'Blue Collar Jobs',
    description: 'Hire or find roles for technicians, helpers, logistics & more. Empowering every hand that builds the future.',
    link: '/services',
    preview: {
      type: 'job',
      bgColor: '#f5f3da',
      bgBorder: '#e9e5aa',
      logo: '/newHome/featured_jobs/ami_lifescience.jpeg',
      company: 'Ami lifescience',
      role: 'Factory helpers',
      tags: ['Urgently Hiring', 'Surat', 'Service'],
    },
  },
  {
    title: 'College Placements',
    description: 'Boost your campus placement rates with dedicated hiring drives and direct access to top-tier industry partners.',
    link: '/services',
    preview: {
      type: 'placement',
      image: '/newHome/dhoondh_offers/9b75a6a4-d65f-42cb-99ed-bc4a46aab89c 1.png',
      tags: ['Ahmedabad', 'B. Tech.', 'Computer Science'],
    },
  },
  {
    title: 'Upskill Yourself',
    description: 'Access affordable courses built around job demand - every skill you gain takes you one step closer to better work.',
    link: '/services',
    preview: {
      type: 'illustration',
      image: '/newHome/dhoondh_offers/OBJECTS.png',
    },
  },
];

/* ─────────────────────────────────────────────
   Sub-components
───────────────────────────────────────────── */
/* Outlined pill — standard grey text (used in job cards / profile) */
const PillTag: FC<{ children: React.ReactNode }> = ({ children }) => (
  <span
    style={{ border: '1px solid #bbb', color: '#8b8b8b', fontSize: '10px', backgroundColor: 'white' }}
    className="inline-flex items-center justify-center h-7 px-3 rounded-[40px] whitespace-nowrap"
  >
    {children}
  </span>
);

/* Darker pill — used where Figma shows border-[#777] text-[#777] (College Placements tags) */
const PillTagDark: FC<{ children: React.ReactNode }> = ({ children }) => (
  <span
    style={{ 
      border: '1px solid #777', 
      color: '#777', 
      fontSize: '14px', 
      backgroundColor: 'white',
      whiteSpace: 'nowrap', // Prevents text inside the pill from breaking
      textAlign: 'right'
    }}
    className="px-4 py-1 rounded-[40px] w-fit" // w-fit ensures pill doesn't stretch
  >
    {children}
  </span>
);

const CtaButton: FC<{ to: string; children: React.ReactNode; className?: string }> = ({
  to,
  children,
  className = '',
}) => (
  <Link
    to={to}
    style={{ backgroundColor: GREEN, fontSize: '18px' }}
    className={`inline-flex items-center justify-center px-[18px] py-[10px] rounded-[14px] text-white font-semibold font-montserrat transition-opacity hover:opacity-90 ${className}`}
  >
    {children}
  </Link>
);

const OutlineButton: FC<{ to: string; children: React.ReactNode; className?: string }> = ({
  to,
  children,
  className = '',
}) => (
  <Link
    to={to}
    style={{ borderColor: GREEN, color: TEXT_SUBTITLE, fontSize: '18px' }}
    className={`inline-flex items-center justify-center px-[18px] py-[10px] rounded-[14px] border-2 font-semibold font-montserrat bg-white transition-colors hover:bg-green-50 ${className}`}
  >
    {children}
  </Link>
);

/* ─────────────────────────────────────────────
   Offer preview cards — pixel-matched to Figma
   Card outer: 380×401px; preview area top 213px; padding ~30px each side.
   All absolute positions below are relative to the 30px-padded content box.
───────────────────────────────────────────── */
const PREVIEW_H = 183; // px — space above the title in each card

const OfferPreviewCard: FC<{ preview: OfferPreview }> = ({ preview }) => {
  const wrap: React.CSSProperties = { position: 'relative', height: PREVIEW_H, marginBottom: 16 };
  const insetShadow = 'inset 0 0 10px 0 white';

  /* ── Job card (White Collar & Blue Collar) ─────────── */
  if (preview.type === 'job') {
    return (
      <div style={{ ...wrap, overflow: 'visible' }} className="offer-card-job">
        {/* Stacked depth layers — hidden, fade in on hover */}
        <div className="job-stack-2" style={{ position: 'absolute', top: 10, left: 10, right: -14, bottom: -10, backgroundColor: preview.bgColor, border: `1px solid ${preview.bgBorder}`, borderRadius: 26, zIndex: 1 }} />
        <div className="job-stack-1" style={{ position: 'absolute', top: 5, left: 5, right: -7, bottom: -5, backgroundColor: preview.bgColor, border: `1px solid ${preview.bgBorder}`, borderRadius: 26, zIndex: 2 }} />

        {/* Default half-bg (fades out on hover) */}
        <div className="job-default-bg" style={{ position: 'absolute', top: 0, bottom: 0, left: 0, width: '49%', backgroundColor: preview.bgColor, border: `1px solid ${preview.bgBorder}`, borderRadius: 26, boxShadow: insetShadow, zIndex: 3 }} />

        {/* Full-width bg (fades in on hover) */}
        <div className="job-hover-bg" style={{ position: 'absolute', inset: 0, backgroundColor: preview.bgColor, border: `1px solid ${preview.bgBorder}`, borderRadius: 26, boxShadow: insetShadow, zIndex: 3 }} />

        {/* White mini job card */}
        <div style={{ position: 'absolute', top: 9, left: 9, right: 9, height: 98, backgroundColor: 'white', borderRadius: 20, boxShadow: '-2px 2px 9px 0 rgba(0,0,0,0.1)', padding: '10px 12px', display: 'flex', alignItems: 'center', gap: 10, zIndex: 4 }}>
          <img src={preview.logo} alt={preview.company} style={{ width: 44, height: 44, borderRadius: 14, border: '1px solid #f8f8f8', objectFit: 'cover', flexShrink: 0 }} />
          <div>
            <p style={{ fontSize: 18, fontWeight: 600, color: 'black', lineHeight: '28px' }}>{preview.company}</p>
            <p style={{ fontSize: 14, color: '#777', lineHeight: '28px' }}>{preview.role}</p>
          </div>
        </div>

        {/* Tag pills */}
        <div style={{ position: 'absolute', bottom: 10, left: 9, display: 'flex', gap: 6, flexWrap: 'wrap', zIndex: 4 }}>
          {preview.tags.map((t, i) => <PillTag key={i}>{t}</PillTag>)}
        </div>

        {/* 100+ badge — fades in on hover */}
        <div className="job-badge" style={{ position: 'absolute', top: -8, right: -8, backgroundColor: '#ef4444', borderRadius: 20, padding: '4px 12px', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 5 }}>
          <span style={{ color: 'white', fontWeight: 700, fontSize: 14 }}>100+</span>
        </div>
      </div>
    );
  }

  /* ── Contractual Hiring ────────────────────────────── */
  if (preview.type === 'contractual') {
    return (
      <div style={wrap} className="offer-card-contractual">
        {/* Green left card with worker image + building overlay */}
        <div
          className="contractual-left-card"
          style={{ position: 'absolute', top: 0, bottom: 0, left: 0, width: '49%', borderRadius: 26, boxShadow: insetShadow, overflow: 'hidden' }}
        >
          {/* Building illustration — fades in on hover */}
          <img
            className="contractual-building"
            src="/newHome/dhoondh_offers/building_contractual.png"
            alt=""
            style={{ position: 'absolute', top: 8, left: 0, width: '100%', height: '50%', objectFit: 'contain' }}
          />
          <img src={preview.workerImage} alt="" style={{position: 'absolute', width: '100%', height: '100%', objectFit: 'cover' }} />
          
        </div>

        {/* White card on right — "We Build Your Dreams" */}
        <div style={{ position: 'absolute', top: 20, left: '53%', right: 0, height: 80, backgroundColor: 'white', borderRadius: 20, boxShadow: '-2px 2px 9px 0 rgba(0,0,0,0.1)', padding: '10px 14px', display: 'flex', alignItems: 'center' }}>
          <p className="we-build-text" style={{ fontSize: 20, fontWeight: 600, lineHeight: '26px' }}>
            We Build<br />Your Dreams
          </p>
        </div>

        {/* Tag pill — border/text darken on hover */}
        <div style={{ position: 'absolute', bottom: 10, right: 0, display: 'flex' }}>
          <span
            className="contractual-pill inline-flex items-center justify-center h-7 px-3 rounded-[40px] whitespace-nowrap"
            style={{ fontSize: '10px', backgroundColor: 'white' }}
          >
            {preview.tag}
          </span>
        </div>
      </div>
    );
  }

  /* ── Resume Builder (profile) ──────────────────────── */
  if (preview.type === 'profile') {
    return (
      <div style={wrap}>
        <div style={{ position: 'absolute', top: 9, left: 9, right: 9, height: 151, backgroundColor: 'white', borderRadius: 20, boxShadow: '-2px 2px 9px 0 rgba(0,0,0,0.1)', padding: '12px', display: 'flex', flexDirection: 'column', gap: 10 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <img src={preview.avatar} alt={preview.name} style={{ width: 50, height: 50, borderRadius: 14, border: '1px solid #f8f8f8', objectFit: 'cover', flexShrink: 0 }} />
            <div>
              <p style={{ fontSize: 18, fontWeight: 600, color: 'black', lineHeight: '28px' }}>{preview.name}</p>
              <p style={{ fontSize: 12, color: '#777', lineHeight: '20px' }}>{preview.role}</p>
            </div>
          </div>
          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
            {preview.tags.map((t, i) => <PillTag key={i}>{t}</PillTag>)}
          </div>
        </div>
      </div>
    );
  }

  /* ── College Placements ────────────────────────────── */
  if (preview.type === 'placement') {
    return (
      <div style={wrap} className="offer-card-placement">
        {/* Default: full-width green card */}
        <div className="placement-hover" style={{ position: 'absolute', inset: 0, backgroundColor: '#e7f2e7', border: '1px solid #b9d6b9', borderRadius: 26, boxShadow: insetShadow, overflow: 'hidden' }}>
          <img src={preview.image} alt="Graduate" style={{ position: 'absolute', left: 7, top: 0, height: '100%', objectFit: 'cover', borderRadius: '20px 0 0 20px' }} />
          <div className="flex flex-col flex-wrap items-end gap-4 mt-4 mr-3">
            <PillTagDark>{preview.tags[0]}</PillTagDark>
            <PillTagDark>{preview.tags[1]}</PillTagDark>
            <PillTagDark>{preview.tags[2]}</PillTagDark>
          </div>
        </div>

       
      </div>
    );
  }

  /* ── Upskill (illustration) ────────────────────────── */
  return (
    <div style={{ ...wrap, display: 'flex', alignItems: 'center', justifyContent: 'center' }} className="offer-card-illustration">
      <div className="illus-bg" style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <img src={preview.image} alt="Upskill" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
      </div>
    </div>
  );
};

/* ─────────────────────────────────────────────
   Main component
───────────────────────────────────────────── */
const HomeNewV2: FC = (): JSX.Element => {
  useScrollToTop();
  const [activeTab, setActiveTab] = useState<'jobseekers' | 'employers'>('jobseekers');

  return (
    <>
      <style>{`
        /* Font aliases */
        .font-montserrat { font-family: 'Montserrat', sans-serif; }

        /* Vertical sliders */
        @keyframes scrollUp {
          from { transform: translateY(0); }
          to   { transform: translateY(-50%); }
        }
        @keyframes scrollDown {
          from { transform: translateY(-50%); }
          to   { transform: translateY(0); }
        }
        .slider-up   { animation: scrollUp   40s linear infinite; }
        .slider-down { animation: scrollDown 40s linear infinite; }
        .slider-up:hover,
        .slider-down:hover { animation-play-state: paused; }

        /* Horizontal marquee (Trusted by Companies) */
        @keyframes marqueeLeft {
          from { transform: translateX(0); }
          to   { transform: translateX(-50%); }
        }
        .marquee-track { animation: marqueeLeft 30s linear infinite; }
        .marquee-track:hover { animation-play-state: paused; }

        /* ── Offer card per-type hover effects ───────────── */

        /* Job: stacked layers + full-bg cross-fade + badge */
        .offer-card-job .job-hover-bg,
        .offer-card-job .job-stack-1,
        .offer-card-job .job-stack-2 { opacity: 0; transition: opacity 0.3s ease; }
        .offer-card-job .job-default-bg { transition: opacity 0.3s ease; }
        .offer-card-job .job-badge {
          opacity: 0;
          transform: scale(0.65);
          transition: opacity 0.50s ease, transform 0.50s ease;
        }
        .group:hover .offer-card-job .job-default-bg { opacity: 0; }
        .group:hover .offer-card-job .job-hover-bg,
        .group:hover .offer-card-job .job-stack-1,
        .group:hover .offer-card-job .job-stack-2 { opacity: 1; }
        .group:hover .offer-card-job .job-badge { opacity: 1; transform: scale(1); }

        /* Contractual: left-card bg + border transition */
        .offer-card-contractual .contractual-left-card {
          background-color: #e7f2e7;
          border: 1px solid #b9d6b9;
          transition: background-color 0.3s ease, border-color 0.3s ease;
        }
        .group:hover .offer-card-contractual .contractual-left-card {
          background-color: #ccebcc;
          border-color: #6fc86f;
        }

        /* Contractual: building illustration fades in on hover */
        .offer-card-contractual .contractual-building {
          opacity: 0;
          pointer-events: none;
          transition: opacity 0.35s ease;
        }
        .group:hover .offer-card-contractual .contractual-building { opacity: 0.8; }

        /* Contractual: "We Build Your Dreams" text turns green */
        .offer-card-contractual .we-build-text { color: #585858; transition: color 0.3s ease; }
        .group:hover .offer-card-contractual .we-build-text { color: #6fc86f; }

        /* Contractual: pill border + text darken on hover */
        .offer-card-contractual .contractual-pill {
          border: 1px solid #bbb;
          color: #8b8b8b;
          transition: border-color 0.3s ease, color 0.3s ease;
        }
        .group:hover .offer-card-contractual .contractual-pill {
          border-color: #585858;
          color: #585858;
        }

        /* Illustration: green bg fades in */
        .offer-card-illustration .illus-bg {
          border-radius: 20px;
          transition: background-color 0.3s ease;
        }
        .group:hover .offer-card-illustration .illus-bg { background-color: #e7f2e7; }

        /* Placement: cross-fade between full-card and split layouts */
        .offer-card-placement .placement-default { transition: opacity 0.25s ease; }
        .offer-card-placement .placement-hover {
          opacity: 1;
          pointer-events: none;
          transition: opacity 0.25s ease 0.05s;
        }
        .group:hover .offer-card-placement .placement-default {
          opacity: 0;
          pointer-events: none;
        }
       
      `}</style>

      <div className="min-h-screen bg-white font-montserrat">

        {/* ── Section 1: Hero ─────────────────────────────── */}
        <section className="relative overflow-hidden pt-24 md:pt-32 lg:pt-28">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
            <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-center">

              {/* Left column */}
              <div className="space-y-5 order-2 lg:order-1">

                {/* Badge */}
                <div className="inline-flex">
                  <span
                    style={{ backgroundColor: GREEN_BADGE_BG, color: GREEN_BADGE_TEXT, fontSize: '16px', borderRadius: '14px' }}
                    className="px-[26px] py-[10px] font-medium"
                  >
                    India's Most Inclusive hiring platform
                  </span>
                </div>

                {/* Heading */}
                <h1
                  style={{ fontSize: 'clamp(32px, 4vw, 46px)', color: '#050505', lineHeight: 1.15 }}
                  className="font-medium"
                >
                  Someone out there<br />
                  is looking for exactly<br />
                  what you offer.
                </h1>

                {/* Hindi tagline */}
                <p
                  style={{
                    fontSize: 'clamp(24px, 3.5vw, 46px)',
                    color: GREEN_DARK,
                    fontFamily: "'Outfit', 'Noto Sans Devanagari', sans-serif",
                    fontWeight: 600,
                  }}
                  className="italic"
                >
                  "काम ढूंढना अब और आसान है &#2404;"
                </p>

                {/* Subtitle */}
                <p
                  style={{ fontSize: 'clamp(16px, 2vw, 22px)', color: TEXT_SUBTITLE }}
                  className="font-medium max-w-lg leading-relaxed"
                >
                  Blue Collar or White Collar -<br className="hidden lg:block" />
                  every job, every city, one platform.
                </p>

                {/* CTA Buttons */}
                <div className="flex flex-col sm:flex-row gap-3 pt-2">
                  <CtaButton to="/register?isJobseeker=true">Search Jobs</CtaButton>
                  <OutlineButton to="/services">Post a Free Job</OutlineButton>
                </div>

                {/* Employer link */}
                
              </div>

              {/* Right column — hero image + trusted colleges badge */}
              <div className="order-1 lg:order-2 flex justify-center lg:justify-end">
                <div className="relative w-full max-w-md md:max-w-lg lg:max-w-[800px]">
                  <img
                    src="/newHome/hero_section_compressed.png"
                    alt="Diverse workers representing inclusive hiring"
                    className="w-full h-auto"
                  />
                  <div className="absolute bottom-4 left-1/2 -translate-x-1/2 w-[100%] max-w-[800px]">
                    <div
                      style={{ backgroundColor: 'rgba(164,164,164,0.31)', borderRadius: '20px' }}
                      className="backdrop-blur-2xl px-4 py-3 shadow-lg"
                    >
                      <p className="text-center text-xs font-semibold text-gray-700 mb-2">
                        Trusted by Colleges
                      </p>
                      <div className="flex items-center justify-center gap-3 flex-wrap">
                        {collegeLogos.map((college, i) => (
                          <img
                            key={i}
                            src={college.src}
                            alt={college.name}
                            className="h-8 md:h-10 lg:h-14 w-auto object-contain transition-all duration-300"
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Trusted by Companies — horizontal marquee */}
          <div className="mt-10 pb-12">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-4">
              <h2 className="text-center font-semibold text-gray-400 pb-8 " style={{ fontSize: '20px' }}>
                63 Lakh+ job seekers • 1,000+ employers • Verified listings
              </h2>
              <h2 className="text-center font-semibold text-black" style={{ fontSize: '20px' }}>
                Trusted by Companies
              </h2>
            </div>
            <div className="overflow-hidden w-full">
              <div className="flex items-center marquee-track hover:[animation-play-state:paused]" style={{ height: '64px', width: 'max-content', gap: '48px', paddingTop: '16px' }}>
                {[...trustedCompanies,...trustedCompanies].map((co, i) => (
                  <img
                    key={i}
                    src={co.src}
                    alt={co.name }
                    // aria-hidden={i >= trustedCompanies.length}
                    className='grayscale hover:grayscale-0 transition-all duration-300'
                    style={{  height: '38px', width: 'auto', objectFit: 'cover', flexShrink: 0 }}
                  />
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* ── Section 2: How Dhoondh Works ────────────────── */}
        <section style={{ backgroundColor: SECTION_GRAY }} className="py-16 md:py-24">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="font-semibold text-black mb-10" style={{ fontSize: 'clamp(28px, 3vw, 40px)' }}>
              How Dhoondh works?
            </h2>

            <div className="grid lg:grid-cols-2 gap-12 items-start">

              {/* Left: tabs + steps */}
              <div>
                {/* Tabs — text-colour based, no background pill */}
                <div className="flex gap-8 mb-8" style={{ borderBottom: '1px solid #e5e7eb' }}>
                  {(['jobseekers', 'employers'] as const).map((tab) => (
                    <button
                      key={tab}
                      onClick={() => setActiveTab(tab)}
                      className="pb-3 transition-colors bg-transparent outline-none"
                      style={{
                        color: activeTab === tab ? GREEN : '#a2a2a2',
                        fontSize: 'clamp(18px, 2vw, 28px)',
                        fontWeight: 600,
                        borderTop: 'none',
                        borderLeft: 'none',
                        borderRight: 'none',
                        borderBottom: activeTab === tab ? `2px solid ${GREEN}` : '2px solid transparent',
                        marginBottom: '-1px',
                      }}
                    >
                      {tab === 'jobseekers' ? 'For Jobseekers' : 'For Employers'}
                    </button>
                  ))}
                </div>

                {/* Steps card */}
                <div
                  className="bg-white rounded-[20px] p-6 md:p-8"
                  style={{ boxShadow: '-4px 4px 8px 0px rgba(80,80,80,0.25)' }}
                >
                  <div className="space-y-6">
                    {(activeTab === 'jobseekers' ? jobseekerSteps : employerSteps).map((step) => (
                      <div key={step.number} className="flex gap-4">
                        <div
                          className="shrink-0 w-10 h-10 rounded-full flex items-center justify-center font-bold text-black"
                          style={{ backgroundColor: GREEN }}
                        >
                          {step.number}
                        </div>
                        <div>
                          <h3 className="font-semibold text-black text-lg">{step.title}</h3>
                          <p className="text-gray-500 text-sm mt-1">{step.description}</p>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="mt-8 flex justify-end">
                    <CtaButton to="/register">Create Account</CtaButton>
                  </div>
                </div>
              </div>

              {/* Right: two vertical sliders */}
              <div className="grid grid-cols-2 gap-1 h-[500px] overflow-hidden">
                {/* Column 1 — scrolls up */}
                <div className="relative overflow-hidden">
                  <div className="slider-up flex flex-col gap-4 md:gap-7">
                    {[...sliderColumn1, ...sliderColumn1].map((img, i) => (
                      <img
                        key={`c1-${i}`}
                        src={img}
                        alt=""
                        className="w-full h-[140px] md:h-[300px] object-contain rounded-xl shrink-0"
                        // style={{ height: '300px' }}
                      />
                    ))}
                  </div>
                </div>

                {/* Column 2 — scrolls down */}
                <div className="relative overflow-hidden">
                  <div className="slider-down flex flex-col gap-4 md:gap-7">
                    {[...sliderColumn2, ...sliderColumn2].map((img, i) => (
                      <img
                        key={`c2-${i}`}
                        src={img}
                        alt=""
                        className="w-full h-[140px] md:h-[300px]  object-contain rounded-xl shrink-0"
                        // style={{ height: '300px' }}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ── Section 3: Browse by Category ───────────────── */}
        <section className="py-16 md:py-24 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center mb-8">
              <h2 className="font-semibold text-black" style={{ fontSize: 'clamp(28px, 3vw, 40px)' }}>
                Jobs by Category
              </h2>
              <Link
                to="/services"
                style={{ color: GREEN_DARK, fontSize: '26px' }}
                className="font-medium hover:underline whitespace-nowrap"
              >
                View All Categories →
              </Link>
            </div>

            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {categories.map((cat, i) => (
                <Link
                  key={i}
                  to="/services"
                  style={{ backgroundColor: '#f8f8f8', borderRadius: '20px' }}
                  className="block p-5 hover:shadow-lg transition-all group"
                >
                  <h3 className="font-semibold text-black mb-1" style={{ fontSize: '20px' }}>
                    {cat.name}
                  </h3>
                  <p className="mb-4" style={{ color: '#777', fontSize: '14px' }}>
                    ({cat.jobs} jobs)
                  </p>
                  <div className="flex gap-2 items-center">
                    {cat.logos.map((logo, j) => (
                      <div
                        key={j}
                        className="overflow-hidden shrink-0"
                        style={{ width: '44px', height: '44px', borderRadius: '14px', border: '2px solid white', marginLeft: j > 0 ? '0px' : '0px', background: '#fff' }}
                      >
                        <img
                          src={logo}
                          alt=""
                          className="w-full h-full object-contain"
                        />
                      </div>
                    ))}
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* ── Section 4: Featured Jobs ─────────────────────── */}
        <section style={{ backgroundColor: SECTION_GRAY }} className="py-16 md:py-24">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="font-semibold text-black mb-10" style={{ fontSize: 'clamp(28px, 3vw, 40px)' }}>
              Featured Jobs
            </h2>

            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {featuredJobs.map((job, i) => (
                <div
                  key={i}
                  className="bg-white rounded-[14px] p-6 hover:shadow-lg transition-all cursor-pointer flex flex-col items-center"
                  style={{ border: '1px solid #e5e7eb' }}
                >
                  {/* Company logo — centered */}
                  <div className="w-16 h-16 rounded-[14px] overflow-hidden mb-4 bg-gray-50 flex items-center justify-center">
                    <img
                      src={job.logo}
                      alt={job.company}
                      className="w-full h-full object-cover"
                    />
                  </div>

                  {/* Company name + role — centered */}
                  <p className="font-semibold text-black text-center" style={{ fontSize: '20px', lineHeight: '28px' }}>
                    {job.company}
                  </p>
                  <p className="text-center mb-4" style={{ color: '#777', fontSize: '16px', lineHeight: '28px' }}>
                    {job.role}
                  </p>

                  {/* Tags — two rows of outlined pills */}
                  <div className="flex flex-col gap-2 w-full">
                    {job.tags.map((row, ri) => (
                      <div key={ri} className="flex gap-2 justify-center flex-wrap">
                        {row.map((tag, ti) => (
                          <PillTag key={ti}>{tag}</PillTag>
                        ))}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── Section 5: Hiring Excellence CTA ────────────── */}
        <section className="py-16 md:py-24 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div className="space-y-6">
                <img
                  src={logoImage}
                  alt="Dhoondh"
                  className="h-5 md:h-7 aspect-auto object-contain transition-transform duration-300 group-hover:scale-105"
                />
                <h2
                  className="font-semibold text-black leading-tight"
                  style={{ fontSize: 'clamp(28px, 3vw, 40px)' }}
                >
                  Hiring excellence is one conversation away.
                </h2>
                <p style={{ color: TEXT_SUBTITLE, fontSize: '18px' }} className="leading-relaxed">
                  Connect with our team and learn how Dhoondh can help your team grow faster and better.
                </p>
                <CtaButton to="/contact">Get in Touch</CtaButton>
              </div>
              <div className="relative flex justify-center">
                <img
                  src="/newHome/hero_section2.png"
                  alt="Professional consultation"
                  className="w-full max-w-md rounded-2xl"
                />
              </div>
            </div>
          </div>
        </section>

        {/* ── Section 6: What Dhoondh Offers ──────────────── */}
        <section
          style={{ backgroundColor: OFFERS_BG }}
          className="py-16 md:py-24"
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* Inner container with border */}
            <div
              style={{ border: `2px solid ${OFFERS_BORDER}`, borderRadius: '20px' }}
              className="bg-white p-8 md:p-12"
            >
              <h2
                className="font-semibold text-black mb-10"
                style={{ fontSize: 'clamp(28px, 3vw, 40px)' }}
              >
                What Dhoondh Offers
              </h2>
              <p style={{ color: TEXT_SUBTITLE, fontSize: '18px' }} className="mb-10 max-w-2xl">
                We handle everything— from planning to sourcing, so you can focus on hiring the best talent.
              </p>

              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {dhoondhOffers.map((offer, i) => (
                  <div
                    key={i}
                    style={{ backgroundColor: SECTION_GRAY, borderRadius: '20px', border: '1.5px solid transparent', transition: 'box-shadow 0.3s ease, border-color 0.3s ease, background-color 0.3s ease' }}
                    className="p-6 hover:shadow-xl group"
                    onMouseEnter={e => {
                      const el = e.currentTarget as HTMLDivElement;
                      // el.style.borderColor = OFFERS_BORDER;
                      el.style.backgroundColor = 'white';
                    }}
                    onMouseLeave={e => {
                      const el = e.currentTarget as HTMLDivElement;
                      // el.style.borderColor = 'transparent';
                      el.style.backgroundColor = SECTION_GRAY;
                    }}
                  >
                    <OfferPreviewCard preview={offer.preview} />

                    <h3 className="font-semibold text-black mb-2" style={{ fontSize: '28px' }}>
                      {offer.title}
                    </h3>
                    <p style={{ color: '#8b8b8b', fontSize: '16px' }} className="font-medium mb-4 leading-relaxed">
                      {offer.description}
                    </p>
                    <Link
                      to={offer.link}
                      style={{ color: GREEN, fontSize: '20px' }}
                      className="font-medium hover:underline inline-flex items-center gap-1 group-hover:gap-3 transition-all duration-300"
                    >
                      View Plans
                      <svg className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                      </svg>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

      </div>
    </>
  );
};

export default HomeNewV2;
